import createReducer from '../../createReducer';
import {
  FETCH_GRAPH_WEATHER_FORECAST,
  FETCH_GRAPH_WEATHER_FORECAST_SUCCESS,
} from '../../../actions/graphs';

const initialState = {
  utcOffset: null,
  days: null,
};

const handlers = {};

handlers[FETCH_GRAPH_WEATHER_FORECAST] = () => initialState;

handlers[FETCH_GRAPH_WEATHER_FORECAST_SUCCESS] = (state, { response }) => ({
  utcOffset: response.associated.utcOffset,
  days: response.data.sunlightTimes,
});

export default createReducer(handlers, initialState);



// WEBPACK FOOTER //
// ./src/reducers/components/graphs/sunlightTimes.js